import { render, staticRenderFns } from "./TheGreetingsIdeasPanelSelect.vue?vue&type=template&id=1056a16c&scoped=true"
import script from "./TheGreetingsIdeasPanelSelect.vue?vue&type=script&lang=js"
export * from "./TheGreetingsIdeasPanelSelect.vue?vue&type=script&lang=js"
import style0 from "./TheGreetingsIdeasPanelSelect.vue?vue&type=style&index=0&id=1056a16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056a16c",
  null
  
)

export default component.exports